import { render } from "./WithLargeScreenShot.vue?vue&type=template&id=a641d32e"
const script = {}
script.render = render

export default script